import { http } from "@/utils/axios";

/**
 * @msg: 获取面授课时名称
 */
export function getMyOpenCourse(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/getCourseList'),
        method: 'get',
        params
    })
}

/**
 * @msg: 获取面授班级
 */
export function getBatchList(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/getBatchList'),
        method: 'get',
        params
    })
}

/**
 * @msg: 添加或修改面授课时
 */
export function saveOrUpdateTeacherCourse(data) {
    return http({
        url: http.baseUrl('courseTeacherManage/saveOrUpdateTeacherCourse'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 添加或修改直播课时
 */
export function saveOrUpdateLiveCourse(data) {
    return http({
        url: http.baseUrl('courseTeacherManage/saveOrUpdateLiveCourse'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取我的面授列表
 */
export function getMyTeacherCourse(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/getMyTeacherCourse'),
        method: 'get',
        params
    })
}

/**
 * @msg: 获取我的直播列表
 */
export function getMyLiveCourse(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/getMyLiveCourse'),
        method: 'get',
        params
    })
}

/**
 * @msg: 获取测验内容
 */
export function getExamsPaperTitle(data) {
    return http({
        url: http.baseUrl('zkolTeacherCourseBatch//getExamsPaperTitle'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 判断是否添加综合测验
 */
export function getHasTest(data) {
    return http({
        url: http.baseUrl('zkolTeacherCourseBatch/hasTest'),
        method: 'post',
        params: http.params(data),
        data
    })
}